import React from 'react';
import { Spinner, Table } from 'reactstrap';

function InventoryDetailsData({ stockData, sku, isLoading }) {
  const allStocks = [
    ...(stockData.lsStockData?.InventoryDetails || []),
    ...(stockData.orionStockData?.InventoryDetails || []),
  ];

  return (
    <div>
      <h5 className="mb-3">Inventory Details of {sku}</h5>
      {allStocks.length > 0 ? (
        <Table bordered>
          <thead>
            <tr>
              <th>Location Code</th>
              <th>Stock</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="2">
                  <Spinner size="sm" />
                </td>
              </tr>
            ) : (
              allStocks.map(({ LocationCode, stock }) => (
                <tr key={LocationCode}>
                  <td>{LocationCode}</td>
                  <td>{stock}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      ) : (
        <p>No inventory details available.</p>
      )}
    </div>
  );
}

export default InventoryDetailsData;
